import { Component, OnDestroy, OnInit, ViewChild, ElementRef, AfterViewChecked , Output, SimpleChanges, EventEmitter} from '@angular/core';
//import * as data from '../.././../../shared/data/data/chat/chat';
import { EmailValidator, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebSocketClientService } from '../../../../web-socket-cliente.service';
import { ChatService } from '../../../../chat.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';


@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.scss']
})

export class ChatBoxComponent implements AfterViewChecked, OnDestroy {

  @Input() ticketId!: string;
  @Input() chats: any = [];
  public chats$ = this.chatService.chats$;
  public isLoading$ = this.chatService.isLoading$;
  public isShow : boolean = false;
  public showEmojiPicker:boolean = false;
  public usuarioSelecionado: any = {};
  public waitingMessageConfirmation: boolean = false;

  public chatForm: FormGroup;
  private destroy$ = new Subject<void>();
  @Input() messageInput: string = '';
  @Input() logadoIsResponsavel: boolean = false;

  constructor(private fb: FormBuilder, private webSocketClientService: WebSocketClientService, private chatService: ChatService, private http: HttpClient,  private toastr: ToastrService, public router: Router) {
    this.chatForm = this.fb.group({
      message: ["", Validators.required],
      domain: ["", Validators.required],
    });
    this.isLoading$.subscribe(value => {
      this.isShow = value;
    });

  }


  @Output() taskRequestedChatEncerrado = new EventEmitter<void>();
  @Output() taskChatInvitation = new EventEmitter<void>();

  trackByFn(index: any, item: any) {
    return item.id; // or whatever unique identifier you are using
  }


  ngAfterViewInit(): void {
    console.log('ngAfterViewInit chamado');
  }
  
  ngOnInit() {
    this.chatService.clearChats();

    let email = localStorage.getItem('username');
    let empresa = localStorage.getItem('idOrganizacao');
    var name = localStorage.getItem('nomeUsuario');

    console.log('conectou ao chat')
    this.webSocketClientService.clientConnect(this.ticketId, name, email, empresa);
    this.chatService.addChats(this.chats);
    this.webSocketClientService.getMessages().pipe(takeUntil(this.destroy$)).subscribe(jsonObject => {

        console.log(jsonObject);
        if(jsonObject.action === 'onclientmessage'){

          let side = ''
          if(jsonObject.data.userData.idsender != "0" ){
            side = 'left'
          }
          else{
             side = 'right'
          }

          let message = jsonObject.data.message;
          // if(jsonObject.data.message.startsWith('data:image'))
          // {
          //    message = `<img src="${message}" style="width: 100%; border-radius: 4px; cursor: pointer;">`
          // }

          this.chatService.addChat({
            side: side,
            name: jsonObject.data.userData.name ,
            message: message,
            time: jsonObject.data.userData.time, 
            pageUrl: jsonObject.data.userData.pageUrl,
            uniqueString: jsonObject.data.userData.uniqueString,
            fileLink: jsonObject.data.userData.fileLink,
            type: jsonObject.data.userData.type
          });

         

          if(jsonObject.data.userData.idsender == "0" )
          {
            let audio = new Audio();
            audio.src = "assets/audio/message-incoming.mp3";
            audio.load();
            audio.play().catch(function(error) {
              console.log('Audio playback failed: ', error);
            });
            
            //const messageToaster = `<span class="fas fa-comments"></span> ${jsonObject.data.userData.name +": "  + message}`;

            const messageToaster = `
                  <span class="fas fa-comments"></span> 
                  <a href="#" id="toaster-link-${jsonObject.data.ticketId}" style="color: white; text-decoration: underline;">
                    ${jsonObject.data.userData.name}-${jsonObject.data.message}
                  </a>
                `;

            this.toastr.show(messageToaster, 'Nova mensagem',{
              enableHtml: true,
              toastClass: 'ngx-toastr toast-custom'
            });

            this.showNotification(jsonObject.data.userData.name, message);

            // Adicionar um evento de clique no link após um pequeno delay para garantir que o toaster foi renderizado
            setTimeout(() => {
              const toastLink = document.getElementById(`toaster-link-${jsonObject.data.ticketId}`);
              if (toastLink) {
                toastLink.addEventListener('click', (event) => {
                  event.preventDefault(); // Impede o comportamento padrão do link
                  this.router.navigateByUrl(`/tickets/${jsonObject.data.ticketId}/edit`);
                });
              }
            }, 100);
        }

        }
        else if (jsonObject.action === 'onclientmessage_received' || jsonObject.action === 'onreadconfirmation') {
          this.waitingMessageConfirmation=false;
          const uniquestring = jsonObject.data.userData.uniqueString;
          const messageDiv = document.querySelector(`[id="${uniquestring}"]`);
          console.log(jsonObject.action);  
          console.log(messageDiv); 
          if (messageDiv) {
            
              // Procura por um contêiner de ícones, ou cria um se não existir
              let iconContainer = messageDiv.querySelector('.icon-container') as HTMLElement;
            
              if (!iconContainer) {
                  iconContainer = document.createElement('span');
                  iconContainer.className = 'icon-container';
                  iconContainer.style.display = 'flex';
                  iconContainer.style.gap = '5px'; // Espaço entre os ícones
                  messageDiv.appendChild(iconContainer);
              }
  
              if (jsonObject.action === 'onclientmessage_received') {
         
                  // Cria o ícone de recebido
                  const receivedIcon = document.createElement('i');
                  receivedIcon.className = 'fa fa-check';
                  receivedIcon.style.color = 'green';
                  receivedIcon.title = 'Recebido';
                  iconContainer.appendChild(receivedIcon);
              }
  
              if (jsonObject.action === 'onreadconfirmation') {
                  // Cria o ícone de lido
                  const readIcon = document.createElement('i');
                  readIcon.className = 'fa fa-eye';
                  readIcon.style.color = 'blue';
                  readIcon.title = 'Lido pelo cliente';
                  iconContainer.appendChild(readIcon);
              }
          }
        }
        else if (jsonObject.action === 'chatend' && jsonObject.data) {
          //
          this.taskRequestedChatEncerrado.emit(); // Emite o evento para o componente pai
          
      }

    });
  }

  solicitarParticiparChat(){
    this.taskChatInvitation.emit();
  }

  showNotification(title: string, body: string) {
    if (Notification.permission === 'granted') {
      console.log('chegou')
      new Notification(title, {
        body: body,
        icon: 'assets/images/notification-icon.png' // Ícone opcional
      });
    }
  }



  showPageUrl(item: any): void {
    if(item.pageUrl)
      alert(item.pageUrl);
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {

      this.usuarioSelecionado.idTicket = this.ticketId;
      this.usuarioSelecionado.name = localStorage.getItem('nomeUsuario');
      this.usuarioSelecionado.idsender = localStorage.getItem('idUsuario');
      this.usuarioSelecionado.empresa = localStorage.getItem('idOrganizacao');
      this.usuarioSelecionado.time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      this.usuarioSelecionado.uniqueString = new Date().toISOString().replace(/[-:.TZ]/g, '') + Math.floor(Math.random() * 1000);


      const formData = new FormData();
      formData.append('file', file);
      formData.append('empresa', this.usuarioSelecionado.empresa);
      formData.append('idTicket', this.usuarioSelecionado.idTicket);
      formData.append('idsender', this.usuarioSelecionado.idsender);
      formData.append('email',this.usuarioSelecionado.name);
      formData.append('name',this.usuarioSelecionado.name);

      const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      const uniqueString = new Date().toISOString().replace(/[-:.TZ]/g, '') + Math.floor(Math.random() * 1000);
      formData.append('time', timestamp);
      formData.append('uniqueString', uniqueString);

      this.http.post(`${environment.apiUrl}/ticket/chat/file`, formData).subscribe(
        (response) => {
          console.log('Arquivo enviado com sucesso', response);
        },
        (error) => {
          console.error('Erro ao enviar o arquivo', error);
        }
      );
    }
  }

  sendMessage(message: string, type: string = 'text'): void {
    this.usuarioSelecionado.idTicket = this.ticketId;
    this.usuarioSelecionado.name = localStorage.getItem('nomeUsuario');
    this.usuarioSelecionado.idsender = localStorage.getItem('idUsuario');
    this.usuarioSelecionado.empresa = localStorage.getItem('idOrganizacao');
    this.usuarioSelecionado.time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    this.usuarioSelecionado.uniqueString = new Date().toISOString().replace(/[-:.TZ]/g, '') + Math.floor(Math.random() * 1000);

    this.waitingMessageConfirmation = true;
    const messageData = {
      action: 'onclientmessage',
      content: {
        userData: this.usuarioSelecionado,
        message: message,
        type: type // Define o tipo como 'text' ou 'image'
      }
    };
    console.log(messageData);
    this.webSocketClientService.sendMessage(messageData);
  }

  send() {
    const message = this.chatForm.value['message'];
    if (message) {
      this.sendMessage(message, 'text');
      this.chatForm.controls['message'].reset();
    }
  }

  @ViewChild('msgerChat', { static: false }) private msgerChat!: ElementRef;

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    try {
      this.msgerChat.nativeElement.scrollTop = this.msgerChat.nativeElement.scrollHeight;
    } catch(err) { }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['messageInput'] && this.chatForm) {
      this.chatForm.patchValue({
        message: changes['messageInput'].currentValue
      });
    }
  }

  isImage(message: string): boolean {
    
    return message.startsWith('data:image');
  }

// Novo método ajustado para colagem de imagens
onPaste(event: ClipboardEvent): void {
  event.preventDefault(); // Impede o comportamento padrão de colar o texto no input

  const items = event.clipboardData?.items;
  if (!items) return;

  const itemsArray = Array.from(items);

  for (const item of itemsArray) {
    if (item.type.startsWith('image')) {
      const file = item.getAsFile();
      if (file) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const base64Image = e.target.result as string;
          // Envia a imagem diretamente sem definir no input
          this.sendMessage(base64Image, 'image');
        };
        reader.readAsDataURL(file);
        break; // Processa apenas a primeira imagem, se houver múltiplos itens
      }
    }
  }
}
  
openImage(event: Event) {
  const target = event.target as HTMLElement;
  if (target.tagName === 'IMG') {
    const imgSrc = target.getAttribute('src');
    if (imgSrc && imgSrc.startsWith('data:image')) {
      // Abre uma nova janela e escreve um HTML com a imagem
      const newWindow = window.open('', '_blank');
      if (newWindow) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>Imagem</title>
              <style>
                body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; }
                img { max-width: 100%; max-height: 100%; }
              </style>
            </head>
            <body>
              <img src="${imgSrc}" alt="Imagem">
            </body>
          </html>
        `);
        newWindow.document.close();
      }
    }
  }
}

ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.complete();
  this.webSocketClientService.disconnect();
}

}
